import { EQueryParameters as EPeriod } from '../../../repositories/valuation-offer-history/v1/get-market-trand';

export function useGetPeriodText(period: EPeriod): string {
  const periodTextMapper = {
    [EPeriod.All]: 'всё время',
    [EPeriod.OneYear]: 'год',
    [EPeriod.OneMonth]: 'месяц',
    [EPeriod.SixMonths]: 'полгода',
    [EPeriod.TwoYears]: '2 года',
  };

  return periodTextMapper[period];
}
